import { Game } from "../../../Game";
import { ModelUtils } from "../../../Utils/ModelUtils";
import { Character } from "../../Player/Character";


/**
 * Typy sekci herniho sveta
 */
export const enum eType {
    topVan,
    botVan,

    parcelCollection_0,
    parcelCollection_1,
    parcelCollection_2,

    road1,
    road2,

    bridge,

    safeArea_0,
    safeArea_1,
    safeArea_2,

    carousel,

    barrier_0,

    botWall,

    LENGTH
}



export abstract class Section {
    /**
     * (RO) Typ rozsirujici sekce
     */
    get type(): eType { return this._type; }
    protected _type: eType;

    /**
     * (RO) Korenova entita sekce
     */
    get root(): pc.Entity { return this._root; }
    protected _root: pc.Entity;

    /**
     * (RO) True, pokud sekce vyzaduje volani update()
     */
    get reqUpdate(): boolean { return this._reqUpdate; }
    private _reqUpdate: boolean;

    /**
     * (RO) True, pokud je sekce aktivni
     */
    private active(): boolean { return this._active; }
    protected _active: boolean;

    /**
     * (RO) Velikost sekce (na ose Z)
     */
    get size(): number { return this._size; }
    protected _size: number;

    /**
     * (RO) Horni pozice sekce na ose Z
     */
    get top(): number { return this._root.getLocalPosition().z; }

    /**
     * (RO) Dolni pozice sekce na ose Z
     */
    get bottom(): number { return this._root.getLocalPosition().z + this._size; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(name: string, type: eType, reqUpdate: boolean = false) {
        // Vytvorit root node
        this._root = new pc.Entity(name);

        this._type = type;
        this._reqUpdate = reqUpdate;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(z: number, initData?: SectionInitData): Section {
        this._root.setPosition(0, 0, 0);

        if (!this._active) {
            this._active = true;

            // Pridat entity hernich objektu
            this.addObjectEntities();
            //this.logChildrenPos();

            // Vypocitat celkovou velikost sekce a zarovnat jednotlive entity do root entity
            this.calculateSize();
            //this.logChildrenPos();

            // Pridat sekci do herniho sveta
            Game.APP.root.addChild(this._root);
        }

        // Nastavit pozici rootu        
        this._root.setPosition(0, 0, z);
        this._root.enabled = true;
        //this.logChildrenPos();

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    /*private logChildrenPos(): void {
        let children = this._root.children;
        let locPos = new pc.Vec3();
        let worldPos = new pc.Vec3();

        console.log("-----------------------");

        children.forEach((child: pc.GraphNode, i: number) => {
            locPos.copy(child.getLocalPosition());
            worldPos.copy(child.getPosition());

            console.log("name: " + child.name + " | local: " + locPos.x + "x" + locPos.y + "x" + locPos.z + " | world: " + worldPos.x + "x" + worldPos.y + "x" + worldPos.z);
        });
    }*/

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    deactivate(): Section {
        if (!this._active)
            throw new Error("Section has been already deactivated!");

        // Odstranit vsechny dcerinne entity
        while (this._root.children.length != 0) {
            let ent = this._root.children[0];

            this._root.removeChild(ent);
            ent.enabled = false;
        }

        // Odstranit root entitu
        Game.APP.root.removeChild(this._root);
        this._root.enabled = false;

        this._active = false;

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void { }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void { }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    destroy(): void {
        this._root.destroy();
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @param plChar Overit kolize s postavou hrace
     */
    //-------------------------------------------------------------------------
    checkPlCollisions(plChar: Character): void { }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected abstract addObjectEntities(): void;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected calculateSize(): void {
        let bbox = new pc.BoundingBox();
        ModelUtils.getEntityTotalAABB(this._root.children[0] as pc.Entity, bbox);

        // Zarovnat entity tak aby root byl 0, 0, 0
        let shift = new pc.Vec3(bbox.center.x - bbox.halfExtents.x, 0/*bbox.center.y - bbox.halfExtents.y*/, bbox.center.z - bbox.halfExtents.z);

        this._root.children.forEach((node: pc.GraphNode) => {
            let pos = node.getLocalPosition();
            pos.sub(shift);
            node.setLocalPosition(pos);
        });

        // Velikost sekce na ose Z
        this._size = bbox.halfExtents.z * 2;
    }
}



/**
 * Inicializacni data sekce
 */
export class SectionInitData {
    /**
     * (RO) Typ sekce
     */
    get sectionType(): eType { return this._sectionType; }
    private _sectionType: eType;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(sectionType: eType) {
        this._sectionType = sectionType;
    }
}